import React from 'react'

const PlanFooter = (props) =>{

return (
    <div className="card-footerr">
          <div>
            <p><b>Od:</b> <i>{props.operaterOd}</i></p>
          </div>
          <div>
            <b>Za:</b>{' '}
            {Array.isArray(props.operaterZa) ? (
              props.operaterZa.length > 0 ? (
                <span className="assignee-chips">
                  {props.operaterZa.map((name, i) => (
                    <span key={i} className="assignee-chip" title={name}>{name}</span>
                  ))}
                </span>
              ) : <i>-</i>
            ) : (
              <i>{props.operaterZa}</i>
            )}
          </div>
          <div>
            <p><b>Prioritet:</b> <i style={{ color: props.warn && 'red', fontWeight: props.warn && '700', fontSize: props.warn && '12px'}}>{props.prioritet}</i></p>
          </div>
      </div>
)
}
export default PlanFooter;